import { createAsyncThunk } from '@reduxjs/toolkit'
import ApprovalRequestLog from './approval-request-log-model'
import {
  delete_approvalRequestLog,
  load_approvalRequestLogs,
  store_approvalRequestLog,
} from './approvalRequestLog-service'

export const LoadApprovalRequestLogsAsync = createAsyncThunk<any, any>(
  'composer/load/approvalRequestLog',
  async (params: { uid: string }) => {
    return await load_approvalRequestLogs(params)
  },
)

export const CreateApprovalRequestLogAsync = createAsyncThunk<any, any>(
  'composer/create/approvalRequestLog',
  async (params: ApprovalRequestLog) => {
    return await store_approvalRequestLog(params)
  },
)

export const DeleteApprovalRequestLogAsync = createAsyncThunk<any, any>(
  'composer/delete/approvalRequestLog',
  async (params) => {
    return await delete_approvalRequestLog(params)
  },
)
